import React from "react";

import { GithubCorner } from "../../lib";

export default () => (
  <div style={{ height: "100px"}}>
    <GithubCorner />
  </div>);



// WEBPACK FOOTER //
// ./src/GithubCorner/demo/default.js